// Fallback fiat currency options for currency pickers when the tenant's ENABLED currencies
// (admin settings `rcoin`) can't be loaded — keeps the picker usable rather than empty. This is
// the single source of truth; consumers import it instead of hardcoding their own list.
export const FALLBACK_CURRENCIES = ["USD", "EUR", "CAD", "NOK", "PLN", "SEK", "DKK", "BRL", "JPY", "TRY", "CLP", "MXN"]
